<template>
  <el-dialog
    title="创建发货单"
    :visible.sync="visible"
    width="720px"
    append-to-body=""
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      label-width="100px"
      :rules="rules"
      :model="orderInfo">
      <el-form-item label="出库单号:">{{ orderInfo.code }}</el-form-item>
      <el-form-item label="出库类型:">{{ orderInfo.type| outTypeName() }}</el-form-item>
      <el-form-item label="发货仓库:">{{ orderInfo.warehouseNo | warehouseName() }}</el-form-item>
      <el-form-item
        label="包裹数量:"
        prop="packageNum">
        <el-input-number
          v-model="orderInfo.packageNum"
          :min="1"
          :max="100"
          :precision="0"></el-input-number>
      </el-form-item>
      <el-form-item
        label="物流方式:"
        prop="transType">
        <el-radio-group v-model="orderInfo.transType">
          <el-radio-button :label="1">陆运</el-radio-button>
          <el-radio-button :label="2">空运</el-radio-button>
          <el-radio-button :label="3">自提</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="orderInfo.transType !== 3"
        label="快递模板:"
        prop="expressCode">
        <ent-logistics-select
          v-model="orderInfo.expressCode"
          :option="{vendorId: userInfo.orgId}" />
      </el-form-item>
      <el-form-item
        label="收件人姓名:"
        prop="receiverName">
        <el-input v-model="orderInfo.receiverName"></el-input>
      </el-form-item>
      <el-form-item
        label="收件人手机:"
        prop="receiverMobile">
        <el-input v-model="orderInfo.receiverMobile"></el-input>
      </el-form-item>
      <el-form-item
        label="收件人电话:"
        prop="receiverTel">
        <el-input v-model="orderInfo.receiverTel"></el-input>
      </el-form-item>
      <el-form-item
        :required="orderInfo.transType !== 3"
        style="margin-bottom:0"
        label="收件省市区:">
        <el-row :gutter="0">
          <el-col :span="7">
            <el-form-item
              label-width="0"
              prop="receiverProvince">
              <el-input v-model="orderInfo.receiverProvince"></el-input>
            </el-form-item>
          </el-col>
          <el-col
            :span="7"
            :offset="1">
            <el-form-item
              label-width="0"
              prop="receiverCity">
              <el-input v-model="orderInfo.receiverCity"></el-input>
            </el-form-item>
          </el-col>
          <el-col
            :span="7"
            :offset="1">
            <el-form-item
              label-width="0"
              prop="receiverDistrict">
              <el-input v-model="orderInfo.receiverDistrict"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item
        label="收件地址:"
        prop="receiverAddress">
        <el-input v-model="orderInfo.receiverAddress"></el-input>
      </el-form-item>
      <el-form-item
        label="发货明细:"
        prop="detailList">
        <el-table
          v-loading="loading"
          max-height="400px"
          :data="orderInfo.detailList"
          border>
          <el-table-column
            :resizable="false"
            label="商品名称"
            prop="skuName"></el-table-column>
          <el-table-column
            :resizable="false"
            label="商品编码"
            width="120"
            prop="skuCode"></el-table-column>
          <el-table-column
            label="发货数量"
            width="100"
            :resizable="false"
            prop="num">
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        @click="add">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import EntLogisticsSelect from '../../../components/business/ent-logistics-select.vue'
// import ProductSelectModal from './product-select-new-modal.vue'
import { mapState } from 'vuex'
// import _ from 'lodash'
export default {
  name: 'OrderSendModal',
  components: { EntLogisticsSelect },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      salesOrderId: null,
      orderInfo: {},
      visible: false
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      warehouse: state => state.account.warehouse
    }),
    rules() {
      const { receiverMobile, receiverTel, transType } = this.orderInfo
      return {
        transType: [{ required: true, message: '请选择发货方式', trigger: 'change' }],
        expressCode: [{ required: true, message: '请选择物流公司', trigger: 'change' }],
        receiverName: [{ required: true, message: '请输入收件人姓名', trigger: 'blur' }],
        receiverMobile: [{ required: (!receiverMobile && !receiverTel), message: '收件人手机/电话至少填写一个', trigger: 'blur' }],
        receiverTel: [{ required: (!receiverMobile && !receiverTel), message: '收件人手机/电话至少填写一个', trigger: 'blur' }],
        receiverProvince: [{ required: transType !== 3, message: '请输入收件省份', trigger: 'blur' }],
        receiverCity: [{ required: transType !== 3, message: '请输入收件城市', trigger: 'blur' }],
        receiverDistrict: [{ required: transType !== 3, message: '请输入收件区县', trigger: 'blur' }],
        receiverAddress: [{ required: transType !== 3, message: '请输入收件地址', trigger: 'blur' }]
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.$refs.ruleForm.clearValidate()
    },
    add() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          const { expressCode, id: outOrderId, packageNum, receiverName, receiverMobile, receiverTel, receiverProvince, receiverCity, receiverDistrict, receiverAddress, transType } = this.orderInfo
          this.$store.dispatch('outstock/sendadd', {
            payload: {
              expressCode, outOrderId, packageNum, receiverName, receiverMobile, receiverTel, receiverProvince, receiverCity, receiverDistrict, receiverAddress, transType
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('outstock/outdetail', {
        payload: {
          outOrderId: this.outOrderId
        },
        success: res => {
          this.loading = false
          this.$set(this, 'orderInfo', {
            ...res.data.data,
            expressCode: null,
            packageNum: 1,
            receiverName: '',
            receiverTel: '',
            receiverMobile: '',
            receiverProvince: '',
            receiverCity: '',
            receiverDistrict: '',
            receiverAddress: '',
            transType: 1
          })
          this.salesdetail(res.data.data.bizOrderId)
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    salesdetail(salesOrderId) {
      this.$store.dispatch('outstock/salesdetail', {
        payload: {
          salesOrderId
        },
        success: res => {
          const data = res.data.data
          this.orderInfo.transType = data.transType
          this.orderInfo.expressCode = +data.logisticsCode || null
          this.orderInfo.receiverName = data.receiverName
          this.orderInfo.receiverTel = data.receiverTel
          this.orderInfo.receiverMobile = data.receiverMobile
          this.orderInfo.receiverProvince = data.receiverProvince
          this.orderInfo.receiverCity = data.receiverCity
          this.orderInfo.receiverDistrict = data.receiverDistrict
          this.orderInfo.receiverAddress = data.receiverAddress
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate()
          })
        },
        fail: () => {
          // this.loading = false
        }
      })
    },
    fetch(outOrderId) {
      this.outOrderId = outOrderId
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
